<!-- TOPNAV -->
<nav class="main-header navbar navbar-expand bg-primary-catch navbar-light border-bottom navigation-top">
  <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
    <ul class="navbar-nav">
      <li class="nav-item nav-item-hamburger">
        <a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
      </li>
    </ul>
    <div *ngIf="user.role.name === 'user' && (router.url === '/dashboard/vehicles' || router.url.includes('/dashboard/vehicles?') || router.url.match('/crop/dashboard|/settings')) && !router.url.match('settings#logos|settings#webhooks')" class="credit-info">
      <h4 *ngIf="user.usePremium" translate>customer.premiumCredits<br><strong>{{user.client?.premiumCredits}}</strong></h4>
      <h4 *ngIf="!user.usePremium" translate>global.credit<br><strong>{{user.client?.credits}}</strong></h4>
    </div>

    <ul class="navbar-nav ml-auto">
      <!-- <li class="profile_name"> test1</li>
      <li class="profile_picture"
        [style.background-image]="profilePicture?.fileInfo?.path ? 'url(' + profilePicture.fileInfo.path + ')' : 'url(/assets/img/catcher.png)' ">
      </li> -->
      <li>
        <div id="lang" class="px-3 py-2" style="cursor: pointer; display: flex;" (click)="openDropdown()">
          <img class="small-img" [style.background-image]="(language === 'de') ? 'url(assets/img/germany.webp)' : 
                                (language === 'pt') ? 'url(assets/img/pt.png)' : 
                                (language === 'it') ? 'url(assets/img/it.png)' :
                                (language === 'hu') ? 'url(assets/img/hu.png)' :
                                (language === 'gr') ? 'url(assets/img/gr.png)' : 'url(assets/img/usa.png)'">
          <p class="mr-1">{{language | uppercase}}</p>
          <i class="fa fa-sort-down"></i>
        </div>
        <div *ngIf="showLanguages" class="languages">
          <div class="d-flex p-2 lang-container" (click)="useLanguage('en')">
            <img class="small-img" src="../../../assets/img/usa.png" alt="">
            <p>EN</p>
          </div>
          <div class="d-flex p-2 lang-container" (click)="useLanguage('de')">
            <img class="small-img" src="../../../assets/img/germany.webp" alt="">
            <p>DE</p>
          </div>
          <div class="d-flex p-2 lang-container" (click)="useLanguage('pt')">
            <img class="small-img" src="../../../assets/img/pt.png" alt="">
            <p>PT</p>
          </div>
          <div class="d-flex p-2 lang-container" (click)="useLanguage('it')">
            <img class="small-img" src="../../../assets/img/it.png" alt="">
            <p>IT</p>
          </div>
          <div class="d-flex p-2 lang-container" (click)="useLanguage('hu')">
            <img class="small-img" src="../../../assets/img/hu.png" alt="">
            <p>HU</p>
          </div>
          <div class="d-flex p-2 lang-container" (click)="useLanguage('gr')">
            <img class="small-img" src="../../../assets/img/gr.png" alt="">
            <p>GR</p>
          </div>
        </div>
      </li>

      <div style="position: relative; margin: 0 8px; cursor: pointer;" (click)="showNotifications = !showNotifications">
        <span style="font-size: 1.6rem;">
          <i class="fa fa-bell" aria-hidden="true"></i>
        </span>
        <div *ngIf="notifications.length" style="position: absolute;
          font-size: .85rem;
          display: flex;
          width: 18px;
          height: 18px;
          background: #d93a3a;
          top: 0;
          right: -5px;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          color: #fff;">
          <p>{{notifications.length}}</p>
        </div>

        <div *ngIf="showNotifications" class="notification-dropdown">
          <ng-container *ngIf="notifications.length">
            <div class="notification-item" *ngFor="let notification of notifications" (click)="openNotification(notification)">
              <!-- Display notification content here -->
              <h6 style="font-weight: bold; text-overflow: ellipsis; overflow: hidden">
                {{ notification?.content?.headLine || 'Notification' }}
              </h6>
              <p *ngIf="notification.contentType === 'string'" style="text-overflow: ellipsis; overflow: hidden; font-size: 0.8rem;">
                {{ notification?.content?.content }}
              </p>
              <p *ngIf="notification.contentType !== 'string'" style="text-overflow: ellipsis; overflow: hidden; font-size: 0.8rem;">
                <i style="font-size: 1rem; color: #c3c3c3;" class="fa fa-file mr-2"></i>Attachment
              </p>
              <p class="mt-3" style="font-size: .8rem; font-weight: bold;">{{ notification.createdAt | customDate }}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="!notifications.length">
            <p style="text-align: center;
            font-size: .85rem;
            padding: 1rem 0;">No new notifications</p>
          </ng-container>
        </div>
      </div>


      <li class="profile_logout"><a (click)="logout()"><i class="fa fa-power-off"></i></a></li>
    </ul>
  </div>
</nav>
<!-- /.TOPNAV -->


<!-- SIDENAV -->
<!-- Main Sidebar Container -->
<aside class="main-sidebar sidebar-dark-primary elevation-4 color-text-primary bg-primary-catch sidebar-catch">
  <!-- Dashboard Name -->

  <!-- Brand Logo -->
  <a href="" routerLink="/" class="brand-link">
    <img src="../../../../assets/img/logo.png" alt="Catch Logo" class="brand-image img-circle" style="opacity: .8">
    <span class="brand-text font-weight-light catch-text"></span>
  </a>
  <!-- <div routerLink="/" class="brand-link"></div> -->

  <!-- Sidebar -->
  <div class="sidebar">

    <div class="user-panel mt-3 pb-3 mb-3 d-flex">
      <div class="image">
        <!-- <img [src]="user.profilePicture" class="img-circle elevation-2" alt="User Image"> -->
        <a href="#" [routerLink]="user.role.name === 'customer' || user.role.name === 'user' ? ['settings'] : []"
          class="d-block"><div class="img-circle elevation-2 profile-picture"
          [style.background-image]="user.profilePicture ? 'url(' + user.profilePicture.path + ')' : 'url(assets/img/catcher.png)'">
        </div></a>
      </div>
      <div class="info">
        <a href="#" [routerLink]="user.role.name === 'customer' || user.role.name === 'user' ? ['settings'] : []"
          class="d-block">{{user.name}}</a>
      </div>
    </div>

    <!-- Sidebar Menu -->
    <nav class="mt-2 sidebar-navigation">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <!-- Dashboard -->
        <!-- <li *ngIf="user.role.name === 'user'" class="nav-item">
          <a href="" class="nav-link dashboard-link" [hidden]="userSimple" routerLink="/dashboard"
            routerLinkActive="active-item ni-dashboard-active" [routerLinkActiveOptions]="{exact: true}">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Dashboard</p>
          </a>
        </li> -->

        <!-- client admin -->
        <!-- Users -->
        <li *ngIf="user.role.name === 'client'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/client/users"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>customer.users</p>
          </a>
        </li>

        <!-- CROP -->
        <li *ngIf="canAccess(['user'], ['simple'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/crop/dashboard"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Crop</p>
          </a>
        </li>

        <!-- Users -->
        <li *ngIf="user.role.name === 'customer'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/customer/users"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>nav.clients</p>
          </a>
        </li>

        <!-- Subcustomers -->
        <li *ngIf="user.role.name === 'customer' && user.customer.allowChilds" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/customer/customers"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>customer.subCustomers</p>
          </a>
        </li>

        <!-- Customer users -->
        <li *ngIf="user.role.name === 'customer'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/customer/all-users"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Users</p>
          </a>
        </li>

        <!-- Vehicles -->
        <li *ngIf="canAccess(['user','client','customer'], ['basic', 'premium'])" class="nav-item">
          <a href="" class="nav-link vehicles-link" [hidden]="userSimple" routerLink="vehicles"
            routerLinkActive="active-item ni-vehicles-active">
            <i class="nav-icon ni-vehicles"></i>
            <p class="text-center" translate>nav.vehicles</p>
          </a>
        </li>

        <!-- Crops -->
        <li *ngIf="canAccess(['client','customer'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="crops"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>Crops</p>
          </a>
        </li>

        <!-- [class.active-item]="isVehicleActive('/dashboard/vehicles')"
            [class.active-item]="isVehicleActive('/dashboard/vehicles')" -->

        <!-- Settings -->
        <li *ngIf="user.role.name !== 'root' && user.role.name !== 'manager'" class="nav-item">
          <a href="" class="nav-link settings-link" routerLink="settings"
            routerLinkActive="active-item ni-settings-active">
            <i class="nav-icon ni-settings"></i>
            <p class="text-center" translate>nav.settings</p>
          </a>
        </li>

        <!-- configurator -->
        <li *ngIf="canAccess(['user', 'client'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="configurator"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>nav.bgConfig</p>
          </a>
        </li>

        <!-- License Plate configurator -->
        <li *ngIf="canAccess(['user', 'client'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="license-plate-configurator"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>nav.licensePlateConfig</p>
          </a>
        </li>

        <!-- --------- MANAGER ------ -->
        <li *ngIf="canAccess(['manager'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/manager"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Users</p>
          </a>
        </li>

        <!-- --------- ROOT ------- -->

        <!-- Customers -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/customers"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Customers</p>
          </a>
        </li>

        <!-- Clients -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/applications"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Clients</p>
          </a>
        </li>

         <!-- Users -->
         <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/users"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Users</p>
          </a>
        </li>

         <!-- Vehicles -->
         <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/vehicles"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Vehicles</p>
          </a>
        </li>

        <!-- Crops -->
        <li *ngIf="canAccess(['root'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="crops"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center" translate>Crops</p>
          </a>
        </li>

        <!-- background requests -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/background-requests"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Background Config</p>
          </a>
        </li>

        <!-- license plate requests -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/license-plate-requests"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">License Plate Config</p>
          </a>
        </li>

        <!-- Presets -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/presets"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Presets</p>
          </a>
        </li>

        <!-- Gifs -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/gifs"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Gifs</p>
          </a>
        </li>

        <!-- Backgrounds -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/backgrounds"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Backgrounds</p>
          </a>
        </li>

        <!-- Features -->
        <li *ngIf="canAccess(['root', 'client'])" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="features"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Features</p>
          </a>
        </li>

         <!-- Body types -->
         <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/body-types"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Body Types</p>
          </a>
        </li>

        <!-- notifications -->
        <li *ngIf="user.role.name === 'root' 
          || (['client', 'customer'].includes(user.role.name) && user?.customer?.isNotify)" class="nav-item">
          <a href="" class="nav-link bell-link" routerLink="notifications"
            routerLinkActive="active-item ni-bell-active">
            <i class="nav-icon ni-bell"></i>
            <p class="text-center">Notifications</p>
          </a>
        </li>

        <!-- Frames -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="frames"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Frames</p>
          </a>
        </li>

         <!-- License Plates -->
         <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="license-plates"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">License Plates</p>
          </a>
        </li>

        <!-- Logos -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="logos"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Logos</p>
          </a>
        </li>

        <!-- Imports -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="imports"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Imports</p>
          </a>
        </li>

        <!-- Social connections -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="social-connections"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Social connections</p>
          </a>
        </li>

        <!-- Vehicle specifications -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="vehicle-specifications"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Vehicle specifications</p>
          </a>
        </li>

        <!-- restore vehicles -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/restore-vehicles"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Restore Vehicles</p>
          </a>
        </li>

        <!-- restore users -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/restore-users"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Restore Users</p>
          </a>
        </li>

        <!-- promo codes -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/promo-codes"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Promo Codes</p>
          </a>
        </li>

        <!-- assistant config -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/assistant-config"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Assistant Config</p>
          </a>
        </li>

        <!-- video configurator -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/video-configurator"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Video Configurator</p>
          </a>
        </li>

        <!-- video configurator -->
        <li *ngIf="user.role.name === 'root'" class="nav-item">
          <a href="" class="nav-link dashboard-link" routerLink="/root/soundtrack-configurator"
            routerLinkActive="active-item ni-dashboard-active">
            <i class="nav-icon ni-dashboard"></i>
            <p class="text-center">Soundtrack Configurator</p>
          </a>
        </li>

        <!-- Privacy Policy -->
        <li *ngIf="user.role.name !== 'root'"  class="nav-item">
          <a href="https://cybertechglobal.github.io/privacy_policy/catch/privacy_policy.html" class="nav-link privacy-link" target="_blank"
            rel="noopener noreferrer">
            <i class="nav-icon ni-privacy"></i>
            <p class="text-center" translate>nav.privacyPolicy</p>
          </a>
        </li>

        <!-- Accessibility Statement -->
        <li *ngIf="user.role.name !== 'root'" class="nav-item">
          <a href="https://panel.catch-system.com/accessibility-statement/"
            class="nav-link accessibility-link"
            target="_blank"
            rel="noopener noreferrer">
            <i class="nav-icon ni-accessibility"></i>
            <p class="text-center">EAA</p>
          </a>
        </li>

      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>
<!-- /.SIDENAV -->

<app-modal (close)="currentNotification = null" [isNotification]="true" *ngIf="currentNotification">
  <div class="modal_container black-text" style="letter-spacing: initial">
    <!-- <h5 class="text-header-modal" translate>Notification</h5> -->
    <div class="modal-body">
      <h5 style="font-weight: bold;" class="mb-3" *ngIf="currentNotification?.content?.headLine">{{currentNotification.content.headLine}}
      </h5>
      <p style="font-size: 1rem;" *ngIf="currentNotification.contentType === 'string'">
        {{currentNotification?.content?.content}}</p>
      <img class="img-fluid" *ngIf="['image', 'gif'].includes(currentNotification.contentType)"
        [src]="currentNotification?.content?.content" />

      <video *ngIf="currentNotification.contentType === 'video'" width="400" class="w-100" controls autoplay muted>
        <source [src]="currentNotification.content.content" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</app-modal>
